import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { InputTextArea } from "@pentabd/ui";

import { CommentType, Comments as CustomComments } from "@components";

import {
  INTERCHANGE_TRANSFER,
  InterchangeTransferDetailsFormDataType,
} from "@validations/HRM/interchangeTransfer/interchangeTransferValidation";

interface CommentsPropType {
  comments: CommentType[];
  isCompleted: boolean;
}

export const Comments = ({ comments, isCompleted }: CommentsPropType) => {
  const { t } = useTranslation();

  const {
    register,
    formState: { errors },
  } = useFormContext<InterchangeTransferDetailsFormDataType>();

  return (
    <div className="p-10">
      <CustomComments data={comments} />
      <div className="d-flex flex-column gap-8 mt-10">
        {!isCompleted && (
          <div className="row">
            <div className="col-lg-10">
              <InputTextArea
                {...register(INTERCHANGE_TRANSFER.COMMENT)}
                placeholder={t("INTERCHANGE_TRANSFER.COMMENTS")}
                className="fs-md"
                error={errors as any}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
